import testimonials from "../../components/ClientInformation/quotes";


/**
 * 
 * @function getDeveloperTestimonial : function to get developer testimonial by countryname;
 * @returns Arrays unique of developer's testimonial
 */
const getDeveloperTestimonial = (countryName) => {
    let responseData = [];
    let testimonialForCountry = countryName ? testimonials.find((testimonial) => testimonial.country === countryName) : null;

    // Case when testimonial in a country is greater than 4
    if (testimonialForCountry && Array.isArray(testimonialForCountry.developers) && testimonialForCountry.developers.length >= 3) {
      const selectedDevelopers = testimonialForCountry.developers.sort(() => Math.random() - Math.random()).slice(0, 3);
      responseData = getTestimonialFromOtherCountry(selectedDevelopers, countryName);

      // Case when testimonial in a country less than 4 and greater than 0
    } else if (testimonialForCountry && Array.isArray(testimonialForCountry.developers) && testimonialForCountry.developers.length && testimonialForCountry.developers.length < 3) {
      responseData = [...testimonialForCountry.developers];
      const existingDevs = {}; // Set this to prevent duplicate developers as each country data are mixed with other countries
      testimonialForCountry.developers.forEach((dev) => {
        if (!existingDevs[dev.name]) existingDevs[dev.name] = 1;
      });

      responseData = getTestimonialFromOtherCountry(responseData, countryName);

      // Case when no testimonial from the country
    } else {
      responseData = [...testimonials[testimonials.length - 1].developers];
    }
    return responseData.sort(() => Math.random() - Math.random()).slice(0, 5);
  }

const getTestimonialFromOtherCountry = (currentTestimonial=[], countryName) => {
  const developersFromOtherCountry = testimonials.filter(
    item => (
      item.country.toLowerCase() !== countryName.toLowerCase() && item.country.toLowerCase() !== 'default'
    ));
  const limit = 5 - currentTestimonial.length
  const responseData = [];
  const existingDevs = {};
  for (let i=0; i<currentTestimonial.length; i++) {
    existingDevs[currentTestimonial[i].name] = 1; 
  }
  for (let i=0; i<developersFromOtherCountry.length; i++) {
      if (responseData.length >= limit) break;
      const devTestimony = developersFromOtherCountry[i].developers;
      for (let j=0; j<=devTestimony.length; j++) {
        if (responseData.length >= limit) break;
        const dev = devTestimony[j];
        if (dev && dev.name && !existingDevs[dev.name] && dev.country.toLowerCase() !== countryName.toLowerCase()) {
          responseData.push(dev);
          existingDevs[dev.name] = 1;
        }
      }
    }

    return [...currentTestimonial, ...responseData]
}
  

  export default getDeveloperTestimonial;
